 // 没有0 
 var time = () => {
         var now = new Date();
         var hour = now.getHours(); //得到小时
         var minu = now.getMinutes(); //得到分钟
         var sec = now.getSeconds(); //得到秒
         var time = hour + ":" + minu + ":" + sec

         return time
     }
     // 补0 
 var timeData = () => {
     var now = new Date();
     var hour = now.getHours(); //得到小时
     var minu = now.getMinutes(); //得到分钟
     var sec = now.getSeconds(); //得到秒
     var time = (hour <= 9 ? '0' + hour : hour) + ":" + (minu <= 9 ? '0' + minu : minu) + ":" + (sec <= 9 ? '0' + sec : sec)

     return time
 }


 var data = () => {
     var dd8 = new Date();
     var y = dd8.getFullYear()
     var m = dd8.getMonth() + 1 < 10 ? '0' + (dd8.getMonth() + 1) : dd8.getMonth() + 1 // 获取当前月份的日期，不足10补0
     var d = dd8.getDate() < 10 ? '0' + dd8.getDate() : dd8.getDate()
     return y + '-' + m + '-' + d
 }


 var weeks = (a, b, c) => {
     var d1 = new Date();
     var d2 = new Date();
     d2.setMonth(0);
     d2.setDate(1);
     var rq = d1 - d2;
     var s1 = Math.ceil(rq / (24 * 60 * 60 * 1000));
     var s2 = Math.ceil(s1 / 7);
     return s2 //周日做为下周的开始计算
 }

 var fendate = () => {
     var dd8 = new Date();
     var y = dd8.getFullYear()
     var m = dd8.getMonth() + 1 < 10 ? '0' + (dd8.getMonth() + 1) : dd8.getMonth() + 1 // 获取当前月份的日期，不足10补0
     var d = dd8.getDate() < 10 ? '0' + dd8.getDate() : dd8.getDate()
     var date = {
         day: d,
         m: m,
         y: y,
         z_m: number2Chinese(y + '-' + m + '-' + d)
     }
     return date
 }

 var number2Chinese = (str) => {
     var chinese = [' ', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
     var numStr = str.replace(/[^0-9]+/g, '');
     var year = chinese[numStr[0]] + chinese[numStr[1]] + chinese[numStr[2]] + chinese[numStr[3]];
     var month = numStr[4] === '0' ? chinese[numStr[5]] : chinese[10] + chinese[numStr[5]];
     var day = '';
     if (numStr[6] === '0') {
         day = chinese[numStr[7]];
     } else if (numStr[6] === '1') {
         if (numStr[7] === '0') {
             day = chinese[10];
         } else {
             day = chinese[10] + chinese[numStr[7]];
         }
     } else if (numStr[6] === '2' || numStr[6] === '3') {
         if (numStr[7] === '0') {
             day = chinese[numStr[6]] + chinese[10];
         } else {
             day = chinese[numStr[6]] + chinese[10] + chinese[numStr[7]];
         }
     }
     return month + '月';
 }

 module.exports = {
     time: time(),
     date: data(),
     weeks: weeks(),
     fendate: fendate(),
     timeData: timeData()
 }